import { IButtonDropdownOptionProps } from '../../../../_core/button/button-dropdown-option-component';
import { showError } from '../../../../../lib/utils';
import toast from 'react-hot-toast';
import { useDeleteTemplate } from '../../../../domains/template/template.service';
import { ITemplateBaseDetails } from '../../../../../lib/types';
import { ITableMultiselectActionProps } from '../../../../_core/table/table.types';
import { IPermanent } from '../../../../domains/request-group/request-group.types';

export const useDeleteTemplateAction = ({
  getSelectedModels,
  clearSelected,
  permanent
}: ITableMultiselectActionProps<ITemplateBaseDetails> & IPermanent): IButtonDropdownOptionProps => {
  const { deleteTemplate } = useDeleteTemplate();

  return {
    onClick: () => {
      const selected = getSelectedModels();
      if (!selected) toast.error('Unable to determine selected');
      else {
        selected.forEach((template) =>
          deleteTemplate({ ...template, permanent }).catch((err: Error) =>
            showError(`Unable to ${permanent ? 'delete' : 'archive'} template ` + template.title, err)
          )
        );
        clearSelected();
      }
    },
    text: permanent ? 'Delete' : 'Archive'
  };
};
